import React from 'react';
import { AdminCrudShell } from '@/components/admin/AdminCrudShell';
import { Badge } from '@/components/ui/badge';
import { formatMoney } from '@/lib/api';

const ACCESS_OPTS = [
  { value: 'pay_per_download', label: 'Pago por descarga' },
  { value: 'free', label: 'Gratis' },
  { value: 'premium', label: 'Premium (incluido en plan)' },
  { value: 'subscription', label: 'Suscripción' },
  { value: 'disabled', label: 'Desactivado' },
];
const STATUS_OPTS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
  { value: 'archived', label: 'Archivado' },
];
const SOURCE_OPTS = [
  { value: 'event', label: 'Evento' },
  // Reservados Fase 06
];

const FILTER_STATUS = [
  { value: '', label: 'Todos' },
  ...STATUS_OPTS,
];

export default function AdminDownloadProducts() {
  return (
    <AdminCrudShell
      title="Productos descargables"
      subtitle="Configura las descargas a la venta (partido completo, replay, highlights…)."
      entity="download-products"
      testIdPrefix="admin-download-products"
      addLabel="Nuevo producto"
      searchPlaceholder="Buscar por título…"
      filters={[{ name: 'status', label: 'Estado', options: FILTER_STATUS }]}
      initialForm={{ source_type: 'event', source_id: '', title: '', description: '', price_cents: 0, currency: 'EUR', access_type: 'pay_per_download', status: 'active', max_downloads_default: '', valid_days_default: '' }}
      columns={[
        { key: 'title', label: 'Título' },
        { key: 'source_type', label: 'Origen' },
        { key: 'access_type', label: 'Acceso', render: (r) => <Badge variant="secondary" className="uppercase tracking-wider text-[10px]">{r.access_type}</Badge> },
        { key: 'price_cents', label: 'Precio', render: (r) => r.access_type === 'free' ? <span className="text-[var(--ns-text-muted)]">Gratis</span> : formatMoney(r.price_cents, r.currency) },
        { key: 'status', label: 'Estado', render: (r) => <Badge className={`text-[10px] uppercase ${r.status === 'active' ? 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]' : 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)]'}`}>{r.status}</Badge> },
      ]}
      formFields={[
        { name: 'source_type', label: 'Tipo de origen', type: 'select', required: true, options: SOURCE_OPTS, hint: 'video / live_replay / player_highlight quedan reservados para Fase 06.' },
        { name: 'source_id', label: 'ID del origen (UUID del evento)', required: true, placeholder: 'UUID del evento', lowercase: false },
        { name: 'title', label: 'Título', required: true, placeholder: 'Descarga partido completo…' },
        { name: 'description', label: 'Descripción', type: 'textarea' },
        { name: 'access_type', label: 'Tipo de acceso', type: 'select', required: true, options: ACCESS_OPTS },
        { name: 'price_cents', label: 'Precio (céntimos)', type: 'number', hint: '790 = 7,90 €. Pon 0 si es gratis.' },
        { name: 'currency', label: 'Moneda', placeholder: 'EUR', lowercase: false },
        { name: 'max_downloads_default', label: 'Máx. descargas por usuario (opcional)', type: 'number', hint: 'Ej: 3. Vacío = sin límite.', lowercase: false },
        { name: 'valid_days_default', label: 'Días de validez tras compra (opcional)', type: 'number', hint: 'Ej: 30. Vacío = sin caducidad.', lowercase: false },
        { name: 'status', label: 'Estado', type: 'select', required: true, options: STATUS_OPTS },
      ]}
    />
  );
}
